import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
const AntTabs = withStyles({
  root: {
    // borderBottom: '1px solid #e8e8e8',
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
    border: 'solid 1px #e0e0e0',
    backgroundColor: '#ffffff',
  },
  indicator: {
    height: '4px',
    backgroundColor: '#1c8c51',
  },
})(Tabs);

const AntTab = withStyles(theme => ({
  root: {
    textTransform: 'none',
    fontFamily: 'Poppins',
    '&$selected': {
      color: 'dark-blue-grey',
      fontSize: '14px',
      fontWeight: 500,
      textAlign: 'center',
    },
  },
  selected: {},
}))(props => <Tab disableRipple {...props} />);

const StyledTabs = withStyles({
  indicator: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    '& > div': {
      maxWidth: 40,
      width: '100%',
      backgroundColor: '#635ee7',
    },
  },
})(props => <Tabs {...props} TabIndicatorProps={{ children: <div /> }} />);

const StyledTab = withStyles(theme => ({
  root: {
    textTransform: 'none',
    color: '#fff',
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    '&:focus': {
      opacity: 1,
    },
    fontFamily: 'Poppins',
  },
}))(props => <Tab disableRipple {...props} />);

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
}));

export default function CustomizedTabs(props) {
  const classes = useStyles();
  const val = props.value || 0;
  const [value, setValue] = React.useState(val);

  React.useEffect(() => {
    if (props.value >= 0) {
      setValue(props.value);
    }
  }, [props.value]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    props.onTabChange(newValue);
  };

  return (
    <div className={classes.root}>
      <div className={classes.demo1}>
        <AntTabs value={value} onChange={handleChange} aria-label="ant example">
          {props.tabName.map((item, i) => (
            <AntTab
              label={item && item.name ? item.name : item}
              className={item && item.className ? item.className : ''}
            />
          ))}
        </AntTabs>
        <Typography className={classes.padding} />
      </div>
    </div>
  );
}

CustomizedTabs.propTypes = {
  tabName: PropTypes.array,
  onTabChange: PropTypes.func,
  value: PropTypes.number,
};
